import Utils from "../utils";

export function applyFilter(nominations, params) {
    let filtered = nominations;

    if (params.anio) {
        filtered = nominations[params.anio].nominations || [];
    } else {
        filtered = [];
    }

    if (params.category)
        filtered = filtered.filter(
            (nomination) => nomination.category._id == params.category
        );
    if (params.country) {
        filtered = filtered.filter((nomination) => {
            const country =
                nomination.commonFields && nomination.commonFields[0];
            return country == params.country;
        });
    }
    if (params.agency)
        filtered = filtered.filter(
            (nomination) => nomination.agencyName == params.agency
        );
    if (params.medal)
        filtered = filtered.filter(
            (nomination) => nomination.medal == params.medal
        );
    if (params.keywords)
        filtered = filtered.filter((nomination) =>
            Utils.removeAccents(nomination.name.toLowerCase()).includes(
                Utils.removeAccents(params.keywords.toLowerCase())
            ) ||
            Utils.removeAccents(nomination.agencyName.toLowerCase()).includes(
                Utils.removeAccents(params.keywords.toLowerCase())
            ) ||
            Utils.removeAccents(nomination.clientName.toLowerCase()).includes(
                Utils.removeAccents(params.keywords.toLowerCase())
            )
        );

    return filtered;
};